import React from 'react';

import IncomeForm from 'components/IncomeForm';
import { BorrowerType } from 'enums/BorrowerType';

const BorrowerIncome = () => {
  return <IncomeForm borrowerType={BorrowerType.CoBorrower} key="coBorrower" />;
};

export default BorrowerIncome;
